<div
  class="kc-left-sidebar"
  [class.kc-left-sidebar--opened]="sidebarOpen()"
  [class.kc-left-sidebar--mobile-open]="isMobile() && sidebarOpen()"
>
  @if (sidebarOpen()) {
    <div class="kc-left-sidebar__header">
      <a
        routerLink="/markets"
        (click)="closeSidebar()"
        aria-label="KaspaCom KCC20"
      >
        <img
          src="/images/logo-sidebar.png"
          alt="KaspaCom"
          height="32"
          width="154"
        />
      </a>

      @if (isMobile()) {
        <button
          type="button"
          class="kc-left-sidebar__close-button"
          aria-label="Close menu"
          (click)="closeSidebar()"
        >
          <kc-icon
            iconClass="chevron-left"
            size="lg"
            color="var(--kc-color-gray-400)"
          />
        </button>
      }
    </div>

    <div
      class="kc-left-sidebar__search-container"
      role="button"
      tabindex="0"
      aria-haspopup="dialog"
      aria-label="Search tokens"
      (click)="openTokenSearchModal()"
      (keydown.enter)="openTokenSearchModal()"
      (keydown.space)="$event.preventDefault(); openTokenSearchModal()"
    >
      <!-- Presentational only: the wrapper div is the single interactive
           control (role="button"). `inert` removes the inner <input> from the
           tab order and the accessibility tree so there is no duplicate tab
           stop, while clicks still fall through to the wrapper handler. -->
      <kc-input
        inert
        placeholder="Search Tokens"
        variant="search"
        prefixIcon="search"
        [readonly]="true"
        class="kc-left-sidebar__search-input"
      />
    </div>

    <div class="kc-left-sidebar__menu-container">
      @for (group of menuGroups(); track group.label) {
        <div class="kc-left-sidebar__group">
          <div class="kc-left-sidebar__group-label">{{ group.label }}</div>
          @for (mainMenuItem of group.items; track mainMenuItem.value) {
            <a
              [routerLink]="mainMenuItem.path"
              [queryParams]="mainMenuItem.queryParams ?? null"
              (click)="closeSidebar()"
            >
              <div
                class="flex kc-left-sidebar__menu-main-item"
                [class.kc-left-sidebar__menu-main-item--selected]="
                  isMainItemSelected(mainMenuItem)
                "
              >
                <kc-icon
                  [iconClass]="mainMenuItem.iconClass"
                  size="md"
                  [color]="
                    isMainItemSelected(mainMenuItem)
                      ? 'var(--shell-accent)'
                      : 'var(--shell-txt-2)'
                  "
                />
                <div class="kc-left-sidebar__menu-label">
                  <span>{{ mainMenuItem.label }}</span>
                  @if (mainMenuItem.badge) {
                    <span class="kc-sidebar-badge">{{
                      mainMenuItem.badge
                    }}</span>
                  }
                </div>
              </div>
            </a>
          }
        </div>
      }
    </div>
  } @else {
    <a routerLink="/markets" aria-label="KaspaCom KCC20">
      <img
        src="/images/logo-sidebar-minified.png"
        alt="KaspaCom"
        height="32"
        width="53"
      />
    </a>

    <div class="kc-left-sidebar__menu-container-icons">
      <div
        class="kc-left-sidebar__search-icon-container"
        role="button"
        tabindex="0"
        aria-haspopup="dialog"
        aria-label="Search tokens"
        (click)="openTokenSearchModal()"
        (keydown.enter)="openTokenSearchModal()"
        (keydown.space)="$event.preventDefault(); openTokenSearchModal()"
      >
        <div
          class="kc-left-sidebar__search-icon"
          kcTooltip="Search Tokens"
          tooltipPosition="right-center"
        >
          <kc-icon iconClass="search" size="md" color="var(--shell-txt-3)" />
        </div>
      </div>

      @for (mainMenuItem of menuItems(); track mainMenuItem.value) {
        <a
          [routerLink]="mainMenuItem.path"
          [queryParams]="mainMenuItem.queryParams ?? null"
        >
          <div
            class="flex kc-left-sidebar__menu-main-item kc-left-sidebar__menu-main-item-icon"
            [class.kc-left-sidebar__menu-main-item-icon--selected]="
              isMainItemSelected(mainMenuItem)
            "
          >
            <kc-icon
              [iconClass]="mainMenuItem.iconClass"
              size="md"
              [color]="
                isMainItemSelected(mainMenuItem)
                  ? 'var(--shell-accent)'
                  : 'var(--shell-txt-3)'
              "
              [kcTooltip]="mainMenuItem.label"
              tooltipPosition="right-center"
            />
          </div>
        </a>
      }
    </div>
  }
</div>
